export const AppFooter = () => {
  return (
    <div className="layout-footer">
      <span className="font-medium ml-2">Agent CRM</span>
    </div>
  );
}
